var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ckb-documents-list-item catalogid=\"{{$ctrl.catalogid}}\" ng-repeat=\"item in $ctrl.content.records\" item=\"item\"\u003E\u003C\u002Fkb-documents-list-item\u003E";;return pug_html;};
module.exports = template;